// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1C4Pk","colCheckbox":"styles_colCheckbox__3evv-"};